export enum WorkbenchStyle {
  LibertyStyle = 'liberty-style',
  ReedsFerryStyle = 'reeds-ferry-style',
}
